import PropTypes from 'prop-types';

export const snackbarPropType = {
    action: PropTypes.node,
    anchorOrigin: PropTypes.shape({}),
    autoHideDuration: PropTypes.number,
    classes: PropTypes.shape({}),
    ClickAwayListenerProps: PropTypes.shape({}),
    ContentProps: PropTypes.shape({}),
    disableWindowBlurListener: PropTypes.bool,
    snackbarkey: PropTypes.any,
    message: PropTypes.node,
    onEnter: PropTypes.func,
    onEntered: PropTypes.func,
    onEntering: PropTypes.func,
    onExit: PropTypes.func,
    onExited: PropTypes.func,
    onExiting: PropTypes.func,
    open: PropTypes.bool,
    resumeHideDuration: PropTypes.number,
    TransitionComponent: PropTypes.element,
    transitionDuration: PropTypes.shape({}),
    TransitionProps: PropTypes.shape({}),
};
